import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Contact = () => {
    return (
            <div className="text-center p-5 bg-light">
                <h1>For any other query contact us @ </h1>
                <h3 className="text-muted">Prepare the best way for your incoming interviews <a href="mailto:preptalks1@gmail.com">preptalks1@gmail.com</a></h3>
            </div>
    )
};

export default Contact;
